import axios from "axios";

export const getRequestCountry = async (tokenClient) => {


  let config = require(`../config/${tokenClient}/config.json`);
  const url = config.credential.api.url+"destinations_passes";


    const response = await axios.get(url)
      .then(res => {
        return res;
      })
      .catch((err) => {
        return false;
      }); 
  
    return response;

  }
